var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31",
    style: {
      enableBackground: "new 0 0 31 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8,20.9c0.2,0.2,0.5,0.3,0.8,0.4v3.7c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2 c-0.1-0.1-0.2-0.3-0.2-0.5v-3.7C15.3,21.2,15.6,21,15.8,20.9C15.8,20.9,15.8,20.9,15.8,20.9z M22.4,9c-0.5-1.3-1.5-2.4-2.7-3.2 c-1.2-0.8-2.6-1.2-4-1.2c-1.4,0-2.8,0.4-4,1.2C10.6,6.6,9.7,7.7,9.2,9C8,9.6,7,10.4,6.3,11.5c-0.7,1.1-1.1,2.4-1.1,3.7 c0,3.7,3,6.7,6.6,6.8c1.1,0,2.2-0.2,3.2-0.7V18l-4.1-2.1c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3 s0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0.1l3.4,1.7v-4.8 c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5V14l3.4-1.7c0.1,0,0.2-0.1,0.3-0.1 s0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.3s0,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.3 c-0.1,0.1-0.1,0.1-0.2,0.2l-4.1,2.1v5.6c0.9,0.5,2,0.7,3,0.7c0.1,0,0.1,0,0.2,0c3.7-0.1,6.6-3.2,6.6-6.8c0-1.3-0.4-2.6-1.1-3.7 C24.6,10.4,23.6,9.6,22.4,9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBranch);
export default __webpack_public_path__ + "static/media/icon-branch.324572cda27843aa319dfcf5ca5ebac2.svg";
export { ForwardRef as ReactComponent };